export type ScanType = 'ASN' | 'LPN' | 'SKU'
export type FlowType = 'Recepción' | 'Devoluciones'

export const FLOW_TYPE_ID: Record<FlowType, number> = {
  'Recepción': 1,
  'Devoluciones': 2
}

export enum eStepAsnReception {
  ScanStep = 0,
  ResultsStep = 1,
  UnknownIdStep = 2,
  ReceptionStep = 3,
}

export interface AsnReceptionResult {
  asnId: number
  asnNumber: string
  supplierName: string
  supplierOriginName: string
  brandName: string
  unitsQty: number
  createdDate: string
  lpns: string[]
}

export interface AsnReceptionLpnInfoDto {
  asnId: number
  asnNumber: string
  supplierName: string
  supplierOriginName: string
  unitsQty: number
  createdDate: string
  lpns: string[]
}

export interface AsnReceptionState {
  scanType: ScanType
  scanValue: string
  results: AsnReceptionResult[]
  selectedResult: AsnReceptionResult | null
  hideBackButton?: boolean
  stepTitle?: string
  defaultFlowType?: FlowType
  successMessage?: string
}
